module.exports = __webpack_public_path__ + "img/Depape.610a6754.jpeg";